import React from 'react';
import { Link } from 'react-router-dom';
import { useCategoryTree } from '../hooks/useQueries';
import './Footer.css';

const Footer = () => {
  // Only primary (top-level) categories belong in the footer's Shop list
  const { data: categoryTree = [], isLoading: catsLoading } = useCategoryTree();

  return (
    <footer className="footer">
    <div className="footer__top container">
      <div className="footer__brand">
        <Link to="/" className="footer__logo">
          <img
            src={'https://res.cloudinary.com/dfl6zlu16/image/upload/v1784294408/Untitled_design_cnrpon.png'}
            alt="Fcreation Logo"
            className="navbar__logo-image"
          />
        </Link>
        <p className="footer__tagline">
          Where every gift tells a story. Personalised and corporate gifting solutions crafted with love — by F Creation Gifting Studio.
        </p>
        <div className="footer__socials">
          {[
            { label: 'I', href: 'https://www.instagram.com/f_creation09', title: 'Instagram' },
            { label: 'f', href: 'https://www.facebook.com/Fcreation09/', title: 'Facebook' },
            { label: 'W', href: 'https://wa.me/916355592849', title: 'WhatsApp' },
          ].map(s => (
            <a key={s.title} href={s.href} className="footer__social" title={s.title} target={s.href.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer">{s.label}</a>
          ))}
        </div>
      </div>

      <div className="footer__col">
        <h4>Shop</h4>
        <Link to="/products">All Gifts</Link>
        {!catsLoading && categoryTree.map((cat) => (
          <Link key={cat.id} to={`/products?category=${cat.slug}`}>{cat.name}</Link>
        ))}
      </div>

      <div className="footer__col">
        <h4>Help & Support</h4>
        <Link to="/faqs">FAQs</Link>
        <Link to="/policies?tab=shipping">Shipping Policy</Link>
        <Link to="/policies?tab=returns">Returns & Exchange</Link>
        <Link to="/contact">Track Your Order</Link>
      </div>

      <div className="footer__col">
        <h4>Company</h4>
        <Link to="/about">About Us</Link>
        <Link to="/blogs">Blog</Link>
        <Link to="/contact">Contact Us</Link>
        <Link to="/policies?tab=privacy">Privacy Policy</Link>
        <Link to="/policies?tab=terms">Terms & Conditions</Link>
      </div>

      <div className="footer__newsletter">
        <h4>Stay in the loop</h4>
        <p>Get updates on new arrivals, exclusive offers, and gifting inspiration.</p>
        <div className="footer__contact-quick">
          <a href="mailto:fcreation08@gmail.com" className="footer__contact-link">
            📧 fcreation08@gmail.com
          </a>
          <a href="https://wa.me/916355592849" target="_blank" rel="noopener noreferrer" className="footer__contact-link">
            💬 WhatsApp Us
          </a>
        </div>
      </div>
    </div>

    <div className="footer__bottom container">
      <p>© {new Date().getFullYear()} F Creation (The Gifting Studio) – Corporate & Personalized Gifting. All rights reserved.</p>
      <div className="footer__legal">
        <Link to="/policies?tab=privacy">Privacy Policy</Link>
        <Link to="/policies?tab=terms">Terms of Service</Link>
      </div>
    </div>
  </footer>
  );
};

export default Footer;